import { useEffect } from 'react'

import { useFormContext } from 'react-hook-form'

import { FormFieldRow } from '@/components/forms/BookTradeForm/FormFieldRow'
import { BaseStructuredFormFields } from '@/pages/instruments/new-instrument/fields/base-structured.fields'
import { OptionalStructuredFields } from '@/pages/instruments/new-instrument/fields/structured.optional.fields'
import { AutocallBarrierLevelFormField } from '@/pages/instruments/new-instrument/form-fields/AutocallBarrierLevelFormField'
import { AutocallBarrierStepFormField } from '@/pages/instruments/new-instrument/form-fields/AutocallBarrierStepFormField'
import { AutocallYearlyObservationsFormField } from '@/pages/instruments/new-instrument/form-fields/AutocallYearlyObservationsFormField'
import { CouponRateAnnualFormField } from '@/pages/instruments/new-instrument/form-fields/CouponRateAnnualFormField'
import { CouponYearlyObservationsFormField } from '@/pages/instruments/new-instrument/form-fields/CouponYearlyObservationsFormField'
import { KnockDownInputLevelFormField } from '@/pages/instruments/new-instrument/form-fields/KnockDownInputLevelFormField'
import { AutocallStandardSchemaType } from '@/pages/instruments/new-instrument/schemas/autocall-standard.schema'

export interface AutocallStandardFormFieldsProps {}

export const AutocallStandardFormFields: React.FC<AutocallStandardFormFieldsProps> = ({}) => {
  const { trigger } = useFormContext<AutocallStandardSchemaType>()

  useEffect(() => {
    trigger()
  }, [])

  return (
    <div className="grid gap-6 @2xl:grid-cols-2 @2xl:gap-10">
      <BaseStructuredFormFields />
      <div className={'@container flex flex-col gap-6'}>
        <FormFieldRow>
          <AutocallYearlyObservationsFormField />
          <CouponYearlyObservationsFormField />
          <CouponRateAnnualFormField />
          <AutocallBarrierLevelFormField />
        </FormFieldRow>
        <FormFieldRow>
          <KnockDownInputLevelFormField />
          <AutocallBarrierStepFormField />
        </FormFieldRow>
        <OptionalStructuredFields />
      </div>
    </div>
  )
}
